import { PureComponent, Fragment } from 'react';
import { withTranslation } from 'react-i18next';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
  Dropdown,
  Grid,
  Dimmer,
  Loader,
  Segment,
  Button,
  Modal,
} from 'semantic-ui-react';

import { INSTANCE_CONTACT_EMAIL } from '../../../utils/instanceConstant';
import { APP_NAME } from '../../../utils/constant';

import {
  getActPreviewData,
  clearCurrentActivity,
  getReports,
  approvalToggleActivity,
  getReportViaEmail,
} from '../../../store/actions';

import { CustomSegment } from '../../../components';
import { map, isEmpty, get } from '../../../utils/lodash';
import { PermissionDenied } from '../../../components/errorStatus';
import { getActivityType } from '../../../utils';

import {
  ReportActivity,
  TheoryOfChange,
  ActualOutput,
  Notes,
  ParentReportCharts,
  ActualOutcomes,
} from '../form';

import emailSendIcon from '../../../assets/email-send.svg';
import { isParentProgramActivity } from '../../../utils/activity';
import { checkPermissionDenied } from '../../../utils/activity/userPermission';

import './preview.scss';
import '../activities.scss';

class LinkedActivityApproval extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  async linkedApprovalToggle(status) {
    try {
      const { currentActivity, approvalToggleActivity } = this.props;
      this.setState({ loading: true });
      await approvalToggleActivity(
        currentActivity.parentActivity.id,
        currentActivity.id,
        status
      );
      this.setState({ loading: false });
    } catch (error) {
      this.setState({ loading: false });
    }
  }

  render() {
    const { loading } = this.state;
    const { t } = this.props;
    return (
      <Segment loading={loading} disabled={loading}>
        <Grid>
          <Grid.Row className="row-report-approval">
            <Grid.Column mobile={16} tablet={16} computer={4} />
            <Grid.Column
              mobile={16}
              tablet={16}
              computer={4}
              textAlign="center"
            >
              <Button positive onClick={() => this.linkedApprovalToggle(true)}>
                {t('activity.linked_activity_approval.accept_report')}
              </Button>
            </Grid.Column>
            <Grid.Column
              mobile={16}
              tablet={16}
              computer={4}
              textAlign="center"
            >
              <Button negative onClick={() => this.linkedApprovalToggle(false)}>
                {t('activity.linked_activity_approval.review_report')}
              </Button>
            </Grid.Column>
            <Grid.Column mobile={16} tablet={16} computer={4} />
          </Grid.Row>
        </Grid>
      </Segment>
    );
  }
}
export class ActivityPreviewSteps extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      reportAllImagesLoaded: true,
      waitExportLoading: true,
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        waitExportLoading: false,
      });
    }, 5000);
  }

  renderApproval() {
    const { t, currentActivity, user } = this.props;

    if (currentActivity.isLinkedActivity && currentActivity.statusId === 3) {
      if (currentActivity.childApproved) return null;
      const isAllowedToReportApprove = get(currentActivity, 'members', []).find(
        (member) =>
          member.userId === user.id &&
          (member.isProgramCollaborator ||
            member.isProgramAndProjectCollaborator)
      );

      return isAllowedToReportApprove ? (
        <CustomSegment
          title={t('activity.linked_activity_approval.report_approval_title')}
          children={<LinkedActivityApproval {...this.props} />}
          extraMargin
          toggle={false}
        />
      ) : null;
    }
    return null;
  }

  async getAllImages(value) {
    return new Promise((resolve, reject) => {
      try {
        let getAllGraphImages = value['getAllGraphImages'];
        let reportLoaded = value['reportLoaded'];
        let reportAllImagesLoaded = false;

        if (getAllGraphImages || reportLoaded) {
          reportAllImagesLoaded = true;
        } else {
          reportAllImagesLoaded = false;
        }
        this.setState(
          {
            reportAllImagesLoaded,
          },
          () => {
            resolve();
          }
        );
      } catch (error) {
        reject(error);
      }
    });
  }

  showInfoModal() {
    this.setState({
      modal: true,
    });
  }

  render() {
    try {
      const { modal } = this.state;
      const {
        t,
        currentActivity,
        actGetLoading,
        getReports,
        publicView = false,
        festivalTypes,
        user,
        getReportViaEmail,
        scope,
      } = this.props;

      if (isEmpty(currentActivity)) return null;

      const currencyType = get(currentActivity, 'currencyType');

      const libraryOrgName = get(
        currentActivity,
        'owner.organisation.name',
        null
      );
      const libraryActivityManagerName =
        scope === 'organisation'
          ? get(currentActivity, 'owner.name', null)
          : null;

      return (
        <div
          className={`content-layer${
            currentActivity &&
            isParentProgramActivity(currentActivity.activityPlanTypeId)
              ? ' parent-act'
              : ''
          }`}
        >
          <div className="content-container">
            <Grid>
              {publicView ? null : (
                <Grid.Row className="act-row no-print" textAlign="right">
                  <Grid.Column
                    // className="report-graph-col"
                    mobile={16}
                    tablet={16}
                    computer={16}
                    className="export-dropdown-btn"
                  >
                    {
                      <Button
                        size="small"
                        className="Primary-Button export"
                        icon
                        labelPosition="left"
                      >
                        <Dropdown
                          text={t('actions.export')}
                          direction="left"
                          //inline
                          selectOnBlur={false}
                          icon="angle down"
                          //className="export-dropdown-btn"
                        >
                          <Dropdown.Menu>
                            <Dropdown.Item
                              className="dropdown-customItem"
                              onClick={() => {
                                getReportViaEmail(currentActivity.id).then(
                                  (status) => {
                                    if (status) {
                                      this.showInfoModal();
                                    }
                                  }
                                );
                              }}
                              children={
                                <label
                                  style={{
                                    color: 'black',
                                  }}
                                >
                                  {t('actions.download_report')}
                                </label>
                              }
                            />

                            {/* hide for now */}
                            {/*** {user.role === 'admin' && (
                              <Dropdown.Item
                                className="dropdown-customItem"
                                onClick={() => {
                                  getReports(
                                    `/activity/${currentActivity.id}/export-data`,
                                    'previewExport'
                                  ).then((status) => {
                                    if (status) {
                                      this.showInfoModal();
                                    }
                                  });
                                }}
                                children={
                                  <label
                                    style={{
                                      color: 'black',
                                    }}
                                  >
                                    {t('actions.download_json')}
                                  </label>
                                }
                              />
                            )} ***/}
                          </Dropdown.Menu>
                        </Dropdown>
                      </Button>
                    }
                  </Grid.Column>
                </Grid.Row>
              )}
              <Grid.Row className="act-row">
                <Grid.Column
                  mobile={16}
                  tablet={16}
                  computer={16}
                  className="activity-sub-column"
                >
                  <div>
                    <CustomSegment
                      title={currentActivity.name || t('common.activity')}
                      subTitle={
                        libraryOrgName || libraryActivityManagerName ? (
                          <Fragment>
                            {libraryOrgName
                              ? `${t('common.organisation')}: ${libraryOrgName}`
                              : null}
                            {libraryOrgName && libraryActivityManagerName ? (
                              <br />
                            ) : null}
                            {libraryActivityManagerName
                              ? `${t('activity.activity_manager')}: ${libraryActivityManagerName}`
                              : null}
                          </Fragment>
                        ) : null
                      }
                      extraMargin={publicView ? false : true}
                      children={
                        <ReportActivity
                          hideActivityName
                          name={
                            currentActivity.name ? currentActivity.name : '-'
                          }
                          owner={
                            currentActivity.owner
                              ? currentActivity.owner.name
                                ? currentActivity.owner.name
                                : '-'
                              : '-'
                          }
                          type={
                            isParentProgramActivity(
                              currentActivity.activityPlanTypeId
                            )
                              ? getActivityType(currentActivity).title || '-'
                              : get(currentActivity, 'eventDetail.detail', '-')
                          }
                          periodGreenLight={
                            currentActivity.greenLightNotifyDate
                              ? currentActivity.greenLightNotifyDate
                              : '-'
                          }
                          periodStart={currentActivity.eventStartDate}
                          periodEnd={currentActivity.eventEndDate}
                          goal={
                            currentActivity.goal ? currentActivity.goal : '-'
                          }
                          goalDescription={
                            currentActivity.goalDescription
                              ? currentActivity.goalDescription
                              : '-'
                          }
                          summary={
                            currentActivity.summary
                              ? currentActivity.summary
                              : currentActivity.description
                                ? currentActivity.description
                                : null
                          }
                          activityPlanTypeId={
                            currentActivity.activityPlanTypeId
                          }
                          parentFestivals={currentActivity.parentFestivals}
                          festivalTypes={festivalTypes}
                        />
                      }
                      toggle={false}
                      className="activity"
                    />
                    {isParentProgramActivity(
                      currentActivity.activityPlanTypeId
                    ) ? (
                      <CustomSegment
                        className="theory-of-change"
                        title={t('common.theory_of_change')}
                        children={
                          <TheoryOfChange
                            grant
                            currentActivity={
                              currentActivity ? currentActivity : {}
                            }
                            knowing={get(
                              currentActivity,
                              'projectTocKnown',
                              '-'
                            )}
                            willDo={get(currentActivity, 'projectTocDo', '-')}
                            description={null}
                            evidenceTypes={
                              this.props.evidenceTypes
                                ? this.props.evidenceTypes
                                : null
                            }
                            evidence={currentActivity.evidence || []}
                          />
                        }
                        extraMargin
                        toggle={false}
                      />
                    ) : (
                      <Fragment>
                        <CustomSegment
                          title={
                            currentActivity.primaryPolicy
                              ? currentActivity.primaryPolicy.policyName
                                ? `${t('activity.preview.objective_intended_outcomes_with_policy', { policy: currentActivity.primaryPolicy.policyName })}`
                                : t(
                                    'activity.preview.objective_intended_outcomes'
                                  )
                              : t(
                                  'activity.preview.objective_intended_outcomes'
                                )
                          }
                          className="objective_"
                          children={
                            <TheoryOfChange
                              aimLabel={
                                currentActivity.objective
                                  ? currentActivity.objective[0]
                                    ? currentActivity.objective[0].outcome
                                      ? currentActivity.objective[0].outcome
                                          .aiming
                                        ? currentActivity.objective[0].outcome
                                            .aiming
                                        : 'Aiming for '
                                      : 'Aiming for '
                                    : 'Aiming for '
                                  : 'Aiming for '
                              }
                              aim={
                                currentActivity.objective
                                  ? currentActivity.objective[0]
                                    ? currentActivity.objective[0].outcome
                                      ? currentActivity.objective[0].outcome
                                          .contentFormat
                                        ? currentActivity.objective[0].outcome
                                            .contentFormat
                                        : '-'
                                      : '-'
                                    : '-'
                                  : '-'
                              }
                              knowingLabel={
                                currentActivity.objective
                                  ? currentActivity.objective[0]
                                    ? currentActivity.objective[0].outcome
                                      ? currentActivity.objective[0].outcome
                                          .knowing
                                        ? currentActivity.objective[0].outcome
                                            .knowing
                                        : ' and knowing '
                                      : ' and knowing '
                                    : ' and knowing '
                                  : ' and knowing '
                              }
                              knowing={
                                currentActivity.objective
                                  ? currentActivity.objective[0]
                                    ? currentActivity.objective[0].tocKnown
                                      ? currentActivity.objective[0].tocKnown
                                      : '-'
                                    : '-'
                                  : '-'
                              }
                              willDo={
                                currentActivity.objective
                                  ? currentActivity.objective[0]
                                    ? currentActivity.objective[0].tocDo
                                      ? currentActivity.objective[0].tocDo
                                      : '-'
                                    : '-'
                                  : '-'
                              }
                              description={
                                currentActivity.objective
                                  ? currentActivity.objective[0]
                                    ? currentActivity.objective[0].outcome
                                      ? currentActivity.objective[0].outcome
                                          .title
                                        ? currentActivity.objective[0].outcome
                                            .title
                                        : '-'
                                      : '-'
                                    : '-'
                                  : '-'
                              }
                              evidenceTypes={
                                this.props.evidenceTypes
                                  ? this.props.evidenceTypes
                                  : null
                              }
                              evidence={
                                currentActivity.objective
                                  ? currentActivity.objective[0]
                                    ? currentActivity.objective[0].evidence
                                      ? currentActivity.objective[0].evidence
                                      : []
                                    : []
                                  : []
                              }
                            />
                          }
                          extraMargin
                          toggle={false}
                        />
                        {currentActivity.secondaryPolicyId ? (
                          <CustomSegment
                            title={
                              currentActivity.secondaryPolicy
                                ? currentActivity.secondaryPolicy.policyName
                                  ? `${t('activity.preview.objective_intended_outcomes_with_policy', { policy: currentActivity.secondaryPolicy.policyName })}`
                                  : t(
                                      'activity.preview.objective_intended_outcomes'
                                    )
                                : t(
                                    'activity.preview.objective_intended_outcomes'
                                  )
                            }
                            className="objective_"
                            children={
                              <TheoryOfChange
                                aimLabel={
                                  currentActivity.objective
                                    ? currentActivity.objective[1]
                                      ? currentActivity.objective[1].outcome
                                        ? currentActivity.objective[1].outcome
                                            .aiming
                                          ? currentActivity.objective[1].outcome
                                              .aiming
                                          : t('common.aiming_for')
                                        : t('common.aiming_for')
                                      : t('common.aiming_for')
                                    : t('common.aiming_for')
                                }
                                aim={
                                  currentActivity.objective
                                    ? currentActivity.objective[1]
                                      ? currentActivity.objective[1].outcome
                                        ? currentActivity.objective[1].outcome
                                            .contentFormat
                                          ? currentActivity.objective[1].outcome
                                              .contentFormat
                                          : '-'
                                        : '-'
                                      : '-'
                                    : '-'
                                }
                                knowingLabel={
                                  currentActivity.objective
                                    ? currentActivity.objective[1]
                                      ? currentActivity.objective[1].outcome
                                        ? currentActivity.objective[1].outcome
                                            .knowing
                                          ? currentActivity.objective[1].outcome
                                              .knowing
                                          : t('common.and_knowing')
                                        : t('common.and_knowing')
                                      : t('common.and_knowing')
                                    : t('common.and_knowing')
                                }
                                knowing={
                                  currentActivity.objective
                                    ? currentActivity.objective.length > 1
                                      ? currentActivity.objective[1]
                                        ? currentActivity.objective[1].tocKnown
                                          ? currentActivity.objective[1]
                                              .tocKnown
                                          : '-'
                                        : '-'
                                      : '-'
                                    : '-'
                                }
                                willDo={
                                  currentActivity.objective
                                    ? currentActivity.objective.length > 1
                                      ? currentActivity.objective[1]
                                        ? currentActivity.objective[1].tocDo
                                          ? currentActivity.objective[1].tocDo
                                          : '-'
                                        : '-'
                                      : '-'
                                    : '-'
                                }
                                description={
                                  currentActivity.objective
                                    ? currentActivity.objective[1]
                                      ? currentActivity.objective[1].outcome
                                        ? currentActivity.objective[1].outcome
                                            .title
                                          ? currentActivity.objective[1].outcome
                                              .title
                                          : '-'
                                        : '-'
                                      : '-'
                                    : '-'
                                }
                                evidenceTypes={
                                  this.props.evidenceTypes
                                    ? this.props.evidenceTypes
                                    : null
                                }
                                evidence={
                                  currentActivity.objective
                                    ? currentActivity.objective[1]
                                      ? currentActivity.objective[1].evidence
                                        ? currentActivity.objective[1].evidence
                                        : []
                                      : []
                                    : []
                                }
                              />
                            }
                            extraMargin
                            toggle={false}
                          />
                        ) : null}
                      </Fragment>
                    )}
                    <CustomSegment
                      className="key-activity-data"
                      title={t('activity.preview.key_activity_data')}
                      children={
                        <ActualOutput
                          currencyType={currencyType}
                          outputs={
                            currentActivity.eventDetail
                              ? currentActivity.eventDetail.outputFormat
                                ? currentActivity.eventDetail.outputFormat
                                    .format
                                  ? currentActivity.eventDetail.outputFormat
                                      .format
                                  : []
                                : []
                              : []
                          }
                          allData={currentActivity ? currentActivity : {}}
                          volunteers={
                            currentActivity.actualVolunteers
                              ? currentActivity.actualVolunteers
                              : '-'
                          }
                          venue={
                            currentActivity.venues
                              ? currentActivity.venues.length > 0
                                ? currentActivity.venues
                                : []
                              : []
                          }
                        />
                      }
                      extraMargin
                      toggle={false}
                    />
                    {isParentProgramActivity(
                      currentActivity.activityPlanTypeId
                    ) ? (
                      <ParentReportCharts
                        inParentReportPage={true}
                        // getAllImages={(value) => getAllImages(value)}
                      />
                    ) : currentActivity.evaluationPlans ? (
                      <ActualOutcomes
                        getAllImages={(value) => this.getAllImages(value)}
                      />
                    ) : null}
                    <CustomSegment
                      className="analysis-and-reflection"
                      title={t('activity.preview.analysis_and_reflection')}
                      children={
                        <Notes
                          reflection={
                            currentActivity.reflection
                              ? currentActivity.reflection
                              : null
                          }
                          isAnalysisField={currentActivity.isAnalysisField}
                          analysis={
                            currentActivity.analysis
                              ? currentActivity.analysis
                              : ''
                          }
                          evaluationPlans={
                            currentActivity.evaluationPlans
                              ? currentActivity.evaluationPlans
                              : []
                          }
                          // no need to change isParent
                          isParent={isParentProgramActivity(
                            currentActivity.activityPlanTypeId
                          )}
                        />
                      }
                      extraMargin
                      toggle={false}
                    />
                    {this.renderApproval()}
                  </div>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </div>
          <Modal
            open={modal}
            onOpen={() => this.toggle()}
            size={'mini'} //  : 'small'
          >
            <Modal.Content>
              <div className="align-self-center justify-content-center text-center my-3">
                <img
                  className="modal-report-error-img"
                  alt="greenRight"
                  src={emailSendIcon}
                />{' '}
              </div>

              <p className="text-center font-weight-bold my-3 modal-report-error-header">
                {t('activity.preview.report_is_being_generated')}
              </p>
              <p className="text-center modal-report-error-paragraph">
                {t('activity.preview.report_compiled_line1')}
                <br />
                <br />
                {t('activity.preview.report_compiled_line2')}
                <br />
                <br />
                {t('activity.preview.report_compiled_contact')} <br />
                <a
                  className="contactUs"
                  href={`mailto:${INSTANCE_CONTACT_EMAIL}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {INSTANCE_CONTACT_EMAIL}
                </a>
              </p>
            </Modal.Content>
            <Modal.Actions>
              <div className="align-self-center justify-content-center text-center">
                <Button
                  className="modal-proceed px-5"
                  content={t('actions.got_it')}
                  onClick={() => this.setState({ modal: false })}
                />
              </div>
            </Modal.Actions>
          </Modal>
          <Dimmer active={actGetLoading} inverted>
            <Loader size="massive" />
          </Dimmer>
        </div>
      );
    } catch (error) {
      return null;
    }
  }
}

class ActivityPreview extends PureComponent {
  async componentDidMount() {
    const { t } = this.props;
    document.title = `${t('common.activities')} | ${APP_NAME}`;

    try {
      const { match, getActPreviewData, clearCurrentActivity } = this.props;

      if (match.params) {
        await clearCurrentActivity();
        await getActPreviewData(match.params.id);
      }
    } catch (error) {
      console.error(error);
    }
  }

  render() {
    const { currentActivity, user } = this.props;
    if (checkPermissionDenied(user, currentActivity))
      return <PermissionDenied />;
    return <ActivityPreviewSteps {...this.props} />;
  }
}

const mapStateToProps = (state) => {
  return {
    ...state.activity,
    user: state.authentication.user,
    evidenceTypes: state.extra.evidenceTypes,
    festivalTypes: state.extra.festivalTypes,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getActPreviewData,
      clearCurrentActivity,
      getReports,
      approvalToggleActivity,
      getReportViaEmail,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(ActivityPreview));
